import { Props } from './types';
import { Container, Header, Title, HeaderUp } from './styles';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import ProgressBar from './ProgressBar';
import BoxMessage from './BoxMessage';
import Form from './Form';
import Status from '../../../../../components/GetStatus';
import { colorIconConversation } from '../../../Utils';
import { Skeleton } from 'antd';
import GetSeveridade from '../../../components/GetSeveridade';

const LeftContainer: React.FC<Props> = () => {
  const ocorrencia = useSelector((state: ApplicationState) => state.Ocorrencia.data['ocorrencia']);
  const loading = useSelector((state: ApplicationState) => state.Ocorrencia.loading);
  const perfil = useSelector((state: ApplicationState) => state.auth.user?.perfil);
  const showProgressBar = perfil && ['A', 'ANCD'].includes(perfil);
  const colorIcon = colorIconConversation(ocorrencia?.urgencia);

  return (
    <Container>
      {!loading ? (
        <Header>
          <HeaderUp>
            <Title className="themeSLA">
              <span className="protocol" style={{ fontSize: '28px' }}>
                <span style={{ color: colorIcon, marginRight: '3px', fontSize: '28px' }}>#</span>
                {ocorrencia?.protocolo}
              </span>
              <>{ocorrencia?.tipoSolicitacao}</>
            </Title>
            <span style={{ textAlign: 'center' }}>
              <Status acronym={ocorrencia?.status} />
            </span>
          </HeaderUp>

          {showProgressBar ? (
            <div className="headerDown">
              <ProgressBar protocolo={ocorrencia?.protocolo} status={ocorrencia?.status} />
            </div>
          ) : (
            <div style={{ width: '150px', display: 'flex', justifyContent: 'center' }}>
              <GetSeveridade severity={ocorrencia?.urgencia} />
            </div>
          )}
        </Header>
      ) : (
        <Skeleton active />
      )}
      <div style={{ padding: '10px 0' }}>
        <BoxMessage protocolo={ocorrencia?.protocolo} />
      </div>
      <div>
        <Form protocolo={ocorrencia?.protocolo} status={ocorrencia?.status} />
      </div>
    </Container>
  );
};

export default LeftContainer;
